import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import {
  DnvFeatureLayer, DnvMapState, LayerState, LayerType, SetHighlightFeature, ToggleFeaturePanel, Layer as DnvLayer,
  SetSelectedFeatureLayer, FeatureClicked, DnvLatLng
} from 'dnv-lib';
import { Drawing, PropertyInfo, PropertyOwner } from '../../state-management';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dnv-svc-conn-tool',
    templateUrl: './dnv-svc-conn-tool.component.html',
    styleUrls: ['./dnv-svc-conn-tool.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DnvSvcConnComponent implements OnInit, OnChanges {

  @Input() headerHeight: number;
  @Input() panelHeight: number;
  @Input() selectedServiceConnection: any;
  @Output() closePanel = new EventEmitter();
  @Output() openReport = new EventEmitter<string>();
  @Output() openDrawingEmitter = new EventEmitter<{ drawNum: string, drawType: string }>();
  @Output() highlightFeature = new EventEmitter<{ name: string, objectId: number }>();

  scrollHeight: number;

  constructor(
    private sanitizer: DomSanitizer) {

  }

  ngOnChanges(): void {
    if (!this.scrollHeight) {
      this.scrollHeight = this.panelHeight - this.headerHeight + 10;
    }
  }

  ngOnInit(): void {
  }

  closeRightPanel(): void {
    this.closePanel.emit();
  }

  // setUrl(url: string): SafeResourceUrl {
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }

  openSvcConnReport(): void {
    this.openReport.emit(this.selectedServiceConnection.dblink);
  }

  openDrawing(drawingNumber: string): void {
    this.openDrawingEmitter.emit({ drawNum: drawingNumber, drawType: '' });
  }

  isNullOrEmpty(val: any): boolean {
    return (val === null || val === '' || (typeof val === 'number' && val < 0));
  }

  isConnectionCapped(conn: any): boolean {
    const isCappedDate = !!conn.cappedDate; // cappedDate is typically set when the connection is capped except some capped connections still have null dates
    const isCapped = (conn.capped || '').toUpperCase() === 'Y';
    return (isCappedDate || isCapped);
  }

  selectSanitaryConnectionLayer(conn: any): string {
    return this.isConnectionCapped(conn) ? 'Sanitary Service Connections - Cap' : 'Sanitary Service Connections'
  }

  selectStormConnectionLayer(conn: any): string {
    return this.isConnectionCapped(conn) ? 'Storm Service Connections - Cap' : 'Storm Service Connections'
  }

  selectWaterConnectionLayer(conn: any): string {
    return this.isConnectionCapped(conn) ? 'Water Service Connections - Cap' : 'Water Service Connections'
  }

  selectConnection(type: string, objectId: number, collapsed: boolean): void {
    this.highlightFeature.emit({ name: type, objectId: objectId });
  }

  isCollapsed(clickEvent: MouseEvent): boolean {
    // TODO: Find a better way to handle the accordian-style state. This can be foiled by clicking too fast.
    let button = this.getButtonElement(clickEvent.composedPath());
    if (button !== null) {
      return button.getAttribute('aria-expanded') === 'true';
    }
  }

  getButtonElement(eventTargets: EventTarget[]): Element {
    for (let t of eventTargets) {
      if ((t as Element)?.nodeName === 'BUTTON') {
        return t as Element;
      }
    }
    return null;
  }

  sanitize(val: any, units = '', isDate = false): any {
    if (this.isNullOrEmpty(val)) {
      return '—';
    }
    if (isDate) {
      return this.isNullOrEmpty(val) ? '-' : new DatePipe('en-CA').transform(val, 'MMM dd yyyy');
    }
    return '' + val + units;
  }
}
